import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import enAU from './locales/en-AU.json'
import enUS from './locales/en-US.json'
import frFR from './locales/fr-FR.json'

const localeMap: Record<string, string> = {
  'en-us': 'en-US',
  'en-au': 'en-AU',
  'fr-fr': 'fr-FR'
}

i18n
  .use(initReactI18next)
  .init({
    resources: {
      'en-US': {
        translation: enUS
      },
      'en-AU': {
        translation: enAU
      },
      'fr-FR': {
        translation: frFR
      }
    },
    lng: 'en-US',
    fallbackLng: 'en-US',
    interpolation: {
      escapeValue: false
    }
  })

export const getI18nLocale = (locale: string): string => {
  return localeMap[locale.toLowerCase()] || 'en-US'
}

export default i18n
